import React from 'react';
import ProtectedPageSidebar from '../../components/Sidebar/ProtectedPageSidebar';
import { Content } from '../../components/Content';

export const HelpCenter = () => {
  return (
    <Content>
      <ProtectedPageSidebar />
      <h1>Help center page</h1>
    </Content>
  );
};
